/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CabinDTO { 
    priceId?: string;
    cabin?: string;
    currency?: string;
    launchPrice?: number;
    basePrice?: number;
    livePrice?: number;
    recommendedPrice?: number;
    confirmedPrice?: number;
    reason?: string;
    state?: CabinDTO.StateEnum;
    delta?: number;
    singleSupplement?: number;
    businessRule?: number;
    cap?: number;
    holdCabins?: number;
    bookedCabins?: number;
    availableCabins?: number;
    occ?: number;
    paxBooked?: number;
    singlePaxBooked?: number;
    isEligibleForPriceChange?: boolean;
    forecastOcc?: number;
    exportedTimestamp?: string;
    lastActionTimestamp?: string;
    isSingleSupplementIncreaseAlert?: boolean;
    isSingleSupplementDecreaseAlert?: boolean;
    isHierarchyAlert?: boolean;
    isMinMaxAlert?: boolean;
    isSingleTwinEquivalent?: boolean;
}
export namespace CabinDTO {
    export const StateEnum = {
        NoState: 'NO_STATE',
        Confirmed: 'CONFIRMED',
        ConfirmedSingleSupp: 'CONFIRMED_SINGLE_SUPP',
        Rejected: 'REJECTED',
        AutoConfirmed: 'AUTO_CONFIRMED'
    } as const;
    export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
}


